export default "__VITE_ASSET__DrQ8wGrh__"